// İSG uzmanı portalı — auth ekranları düzeni (login / parola sıfırlama).
// Ortalanmış kart + üstte marka ve dil seçici (login öncesi dil değişebilir).

import { LanguageSwitcher, Logo } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <header className="flex items-center justify-between px-4 py-4 sm:px-8">
        <div className="flex items-center gap-2.5 text-fg">
          <Logo className="h-7" title={t('app.name')} />
          <span className="text-muted">·</span>
          <span className="text-sm text-muted">{t('app.expertPortal')}</span>
        </div>
        <LanguageSwitcher />
      </header>

      <main className="flex flex-1 items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>

      <footer className="px-4 py-6 text-center text-xs text-muted">{t('app.tagline')}</footer>
    </div>
  );
}
